import { API_HOST, getHttpGetOptions, getHttpPutOptions, getHttpPostOptions } from '../../utils/api-util';

const getEndpoint = () => `${API_HOST}/party`;

const getViewPersonDetailsEndpoint = (personExternalReference) =>
  `${getEndpoint()}/retrieve/details/${personExternalReference}`;
export const getViewPersonDetailsRequest = (personExternalReference) => [
  getViewPersonDetailsEndpoint(personExternalReference),
  getHttpGetOptions(),
];

const getViewPersonProfileEndpoint = (personExternalReference) =>
  `${getEndpoint()}/retrieve/profile/${personExternalReference}`;
export const getViewPersonProfileRequest = (personExternalReference) => [
  getViewPersonProfileEndpoint(personExternalReference),
  getHttpGetOptions(),
];

const getUpdatePersonDetailsEndpoint = () => `${getEndpoint()}/update/person/details`;
export const getUpdatePersonDetailsRequest = (details) => [
  getUpdatePersonDetailsEndpoint(),
  getHttpPutOptions(details),
];

const getUpdatePersonEmailEndpoint = () => `${getEndpoint()}/update/person/email`;
export const getUpdatePersonEmailRequest = (email) => [getUpdatePersonEmailEndpoint(), getHttpPutOptions(email)];

const getUpdatePersonUsernameEndpoint = () => `${getEndpoint()}/update/person/username`;
export const getUpdatePersonUsernameRequest = (username) => [
  getUpdatePersonUsernameEndpoint(),
  getHttpPutOptions(username),
];

const getUpdateProfilePicturEndpoint = () => `${getEndpoint()}/set/profile-picture`;
export const getUpdateProfilePictureRequest = (profilePicture) => [
  getUpdateProfilePicturEndpoint(),
  getHttpPutOptions(profilePicture),
];

const getSearchOrganisationEndpoint = (companyRegistrationNumber) =>
  `${API_HOST}/registration/search/organisation/${companyRegistrationNumber}`;
export const getSearchOrganisationRequest = (companyRegistrationNumber) => [
  getSearchOrganisationEndpoint(companyRegistrationNumber),
  getHttpGetOptions(),
];

const getResetPasswordInternalEndpoint = () => `${getEndpoint()}/update/password`;
export const getResetPasswordInternalRequest = (input) => [
  getResetPasswordInternalEndpoint(),
  getHttpPutOptions(input),
];

const getViewAllFacilitatorsEndpoint = () => `${getEndpoint()}/view/facilitators`;
export const getViewAllFacilitatorsRequest = () => [getViewAllFacilitatorsEndpoint(), getHttpGetOptions()];

const getAddRepresentativeEndpoint = () => `${getEndpoint()}/add/representative`;
export const getAddRepresentativeRequest = (representative) => [
  getAddRepresentativeEndpoint(),
  getHttpPostOptions(representative),
];

const getDeleteUserDetailsEndpoint = () => `${getEndpoint()}/delete/person`;
export const getDeleteUserDetailsRequest = (data) => [getDeleteUserDetailsEndpoint(), getHttpPostOptions(data)];
